import React, { useState } from 'react';

export const useBusiness = () => {
  const [orgId, setOrgId] = useState('');
  const [businessLevel, setBusinessLevel] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [pageName, setPageName] = useState('DEFAULT');
  const EWB_ENABLED = true;
  const businessDetails = React.useMemo(
    () => ({
      addOrgId: async (orgIdValue: string) => {
        localStorage.setItem("ORGID",orgIdValue);
        setOrgId(orgIdValue);
      },
      addBusinessLevel: async (businessLevelValue: string) => {
        setBusinessLevel(businessLevelValue);
      },
      addBusinessName: async (businessValue: string) => {
        localStorage.setItem("BUSINESSNAME",businessValue);
        setBusinessName(businessValue);
      },
      addPageName: async (pageValue: string) => {
        setPageName(pageValue);
      },
    }),
    []
  );

  return {
    orgId,
    businessLevel,
    businessDetails,
    businessName,
    pageName,
    EWB_ENABLED,
  };
};
